/**
 * Czy zakładka „Reports" ma być widoczna/dostępna. Liczona na addonach WŁAŚCICIELA projektu
 * (`ownerAddons`), bo superadmin na cudzym projekcie ma widzieć to, co widzi klient.
 *
 * `NEW_STATS` jest warunkiem twardym dla wszystkich — builder liczy wyłącznie nowymi wzorami, więc
 * bez tego addona raport rozjechałby się z panelem. `VISIBILITY_REPORT` to natomiast kwestia
 * wykupienia dodatku, dlatego superadmina nie obowiązuje: backend i tak przepuszcza go przez guard
 * (`authorizeProject`), a to on generuje klientom raport, zanim dodatek trafi na konto.
 */
export const canUseVisibilityReport = (
  effectiveAddons: readonly string[],
  isSuperAdmin: boolean
): boolean =>
  effectiveAddons.includes('NEW_STATS') &&
  (isSuperAdmin || effectiveAddons.includes('VISIBILITY_REPORT'));
